import createApi from "./api";

const devicesApi = createApi({
  baseUrl: "device",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "devxcfsdfgvS234DFGHREYHFcxsad34tfdgvf3454dfgd",
  },
});

const reportsApi = createApi({
  baseUrl: `reports`,
  headers: {
    "Content-Type": "application/json",
  },
});

const locationsApi = createApi({
  baseUrl: "admin/locations",
  headers: {
    "Content-Type": "application/json",
  },
});

const notificationsApi = createApi({
  baseUrl: "notifications",
  headers: {
    "Content-Type": "application/json",
  },
});

export default class MonitorService {
  getAlerts({ hw_id }) {
    if (hw_id) {
      return devicesApi.get("notifications", { hw_id, include_ack: 0 });
    } else {
      return notificationsApi.get("list", { include_ack: 0 });
    }
  }

  getBleLogs({ from_ts, to_ts, tag_id }) {
    return reportsApi.post("ble-logs", {
      from_ts,
      to_ts,
      tag_id,
    });
  }

  getLiveDoors({ hw_id, zone_name, work_group }) {
    if (hw_id) {
      return devicesApi.post("location-live", { hw_id, work_group, zone_name, show_all: 1 });
    } else {
      return reportsApi.post("location-live", { work_group, zone_name, show_all: 1 });
    }
  }

  getCameraViews({ door_id, hw_id, from_ts, to_ts }) {
    if (hw_id) {
      return devicesApi.post("screenshots", { door_id, hw_id, from_ts, to_ts });
    } else {
      return reportsApi.post("screenshots", { door_id, from_ts, to_ts });
    }
  }

  getDoorBtc({ door_id, hw_id }) {
    if (hw_id) {
      return devicesApi.get("clock", { hw_id });
    } else {
      return devicesApi.get("clock", { door_id });
    }
  }

  getTopEmployees({ hw_id }) {
    if (hw_id) {
      return devicesApi.post("employee-goals", {
        hw_id,
        page_size: 20,
      });
    } else {
      return reportsApi.post("employee-goals", {
        page_size: 20,
      });
    }
  }

  getDCMap() {
    return locationsApi.get("map");
  }
}
